// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://static.toss.im/tps/main.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://static.toss.im/tps/others.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-family: "Toss Product Sans", "Noto Sans KR", sans-serif;
}

.notice_container {
  display: flex;
  flex-direction: column;
}
.notice_container .notice_container_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  font-family: inherit;
  font-size: 14px;
}
.notice_container .notice_container_body {
  background: white;
  font-family: inherit;
  border-radius: 20px 20px 0 0;
  padding: 20px 24px;
  max-height: 70vh;
  overflow-y: scroll;
}
.notice_container .notice_container_body .main-title {
  font-family: inherit;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
}
.notice_container .notice_container_body .title {
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}
.notice_container .notice_container_body .contents {
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
}
.notice_container .notice_container_body a {
  color: #4493fc;
}`, "",{"version":3,"sources":["webpack://./src/components/Commons/AppNotice/notice.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAKA;EACE,4DAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;AAIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AAFJ;AAKE;EACE,iBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAII;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFN;AAII;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFN;AAII;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFN;AAII;EACE,cCJM;ADEZ","sourcesContent":["@import \"styles/variables\";\n@import \"styles/mixins\";\n@import url(\"https://static.toss.im/tps/main.css\");\n@import url(\"https://static.toss.im/tps/others.css\");\n\np {\n  font-family: \"Toss Product Sans\", \"Noto Sans KR\", sans-serif;\n}\n\n.notice_container {\n  display: flex;\n  flex-direction: column;\n\n  .notice_container_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 8px 16px;\n    font-family: inherit;\n    font-size: 14px;\n  }\n\n  .notice_container_body {\n    background: white;\n    font-family: inherit;\n    border-radius: 20px 20px 0 0;\n    padding: 20px 24px;\n    max-height: 70vh;\n    overflow-y: scroll;\n    .main-title {\n      font-family: inherit;\n      font-size: 20px;\n      font-weight: 700;\n      margin-bottom: 8px;\n    }\n    .title {\n      font-family: inherit;\n      font-size: 16px;\n      font-weight: 700;\n      margin-bottom: 8px;\n    }\n    .contents {\n      font-family: inherit;\n      font-size: 14px;\n      font-weight: 400;\n      margin-bottom: 8px;\n    }\n    a {\n      color: $toss-blue;\n    }\n  }\n}\n","$small-screen: 100vw;\n$medium-screen: 80vw;\n$large-screen: 60vw;\n$xlarge-screen: 40vw;\n$label1-color: #383850;\n$label2-color: #999999;\n$label3-color: #3d2f31;\n$theme-color-primary: #6b63ff;\n$theme-color-primary-light: #6b63ffc5;\n$orange-color: #d98c00;\n$light-orange-color: #f2a61c;\n$yellow-color-light: #ffc145d0;\n$yellow-color-new: #ffc519;\n$vat-theme-color: #495afc;\n$vat-theme-color-dark: #4251e3;\n$vat-theme-color-dark-more: #3b49cc;\n$blue-red-color: #d98c00;\n$yellow-theme-color: #ffc145;\n$red-color: #f80707;\n$deep-red-color: #cb2128;\n$green-color: #4aba64;\n$light-green: #00b33c;\n$app-width: min(768px, 100vw);\n$app-width-extra: min(768px, 101vw);\n$semi-black: #121619;\n$light-black: #373b3e;\n$gray: #67686a;\n$light-gray: #93969a;\n$lighter-gray: #c4c4c4;\n$more-lighter-gray: #c1c7cd;\n$light-white: #fafafa;\n$lighter-white: #f2f4f8;\n$lighter-white2: #f4f5ff;\n$purple: #6c63ff;\n$yellow: #ffe800;\n$blue: #0d6efd;\n$common-border-color: #dde1e6;\n$other-gray: #878d96;\n$app-gray-1: #697077;\n$app-dark-gray: #697077;\n$white: #ffffff;\n$toss-navy: #435a78;\n$toss-ivory: #f9fafb;\n$toss-black: #333d4b;\n$toss-gray: #f3f4f6;\n$toss-blue: #4493fc;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
